import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrev = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M22.589 38.413 8.175 24 22.589 9.586l2.121 2.121L12.417 24 24.71 36.292z" }), /* @__PURE__ */ _jsx("path", { d: "M33.739 38.413 19.326 24 33.739 9.586l2.121 2.121L23.568 24 35.86 36.292z" })] }) })
});
export default SvgPrev;
